import React from "react";
import { Card, Table } from "react-bootstrap";

export default function AnalysisResult({ result, ...props }) {
  return result ? (
    <Card className="mt-2">
      <Card.Body>
        <div className="h6 font-weight-bold">Analysis Result</div>
        <p>
          <span className="font-weight-bold mr-1">Text:</span>
          {result.text}{" "}
        </p>
        <div>
          <span className="font-weight-bold mr-1">Sentiment:</span>
          {result.result.analysis}
        </div>
        <div>
          <span className="font-weight-bold mr-1">Metal:</span>
          {result.result.metal}
        </div>
      </Card.Body>
    </Card>
  ) : null;
}
